import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row, Tooltip } from "antd";
import {
  OrderedListOutlined,
  RollbackOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockTransactionProjectTypeListFilter from "../Filters/StockTransactionProjectTypeListFilter";
import CurrencyFormat from "react-currency-format";

const StockTransactionProjectTypeByStockList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "STOK DEPO LİSTESİ",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(
    () => getTableData(),
    [props.match.params.stockId, tableDataQueryOptions]
  );

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate asc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/StockTransactionProjectType/GetListByStockId/${props.match.params.stockId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response,
        loading: false,
        total: response.length,
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Depo Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => {
        if (!text) return "";

        const shortText =
          text.length <= 50 ? text : text.substring(0, 50) + "...";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Tooltip title={text}>{shortText}</Tooltip>
            {record.isMain && (
              <Tooltip title="Ana Depo">
                <CheckCircleOutlined style={{ color: "green" }} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Depo Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "center",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "center",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.substring(0, 20)?.length < 20
                ? text?.substring(0, 20) + ""
                : text?.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "left",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.substring(0, 20)?.length < 20
                ? text?.substring(0, 20) + ""
                : text?.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Birimi",
      dataIndex: "unit",
      key: "unit",
      align: "center",
    },
    {
      title: "Stok Adedi",
      dataIndex: "count",
      key: "count",
      align: "center",
      render: renderDecimal,
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>
      <StockTransactionProjectTypeListFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        stockId={props.match.params.stockId}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default StockTransactionProjectTypeByStockList;
